import { fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ingressServiceEvent } from '../../actions/actionType/services/ServiceEventMappingActionType';
import {
  addServiceEventMappings,
  clearServiceEventMappings,
  deleteServiceEventMappings,
  updateServiceEventMappings
} from '../../actions/sagaActions/services/ServiceEventMappingSagaActions';
import {
  AddServiceEventMappingRequest,
  DeleteServiceEventMappingRequest,
  UpdateServiceEventMappingRequest
} from '../../actions/types/services/ServiceEventsMappingTypes';
/**
 * Saga to add service operation data list
 * @param requestObject:AddServiceOperationsRequest
 */
export function* addServiceEventMappingData({
  serviceEventMapping
}: AddServiceEventMappingRequest) {
  yield put(addServiceEventMappings(serviceEventMapping));
}

export function* addServiceEventMappingSaga() {
  yield takeEvery(
    ingressServiceEvent.SAVE_SERVICE_EVENT,
    addServiceEventMappingData
  );
}

/**
 * Saga to clear service operation list
 */
export function* clearServiceEventMappingSaga() {
  yield put(clearServiceEventMappings());
}

export function* clearServiceEventMappingDataSaga() {
  yield takeLatest(
    ingressServiceEvent.CLEAR_SERVICE_EVENT,
    clearServiceEventMappingSaga
  );
}

/**
 * Delete service operation
 * @param index : number
 */
export function* deleteServiceEventMappingData({
  payload
}: DeleteServiceEventMappingRequest) {
  yield put(deleteServiceEventMappings(payload));
}

export function* deleteServiceEventMappingDataSaga() {
  yield takeLatest(
    ingressServiceEvent.DELETE_SERVICE_EVENT,
    deleteServiceEventMappingData
  );
}

/**
 * Updates service operation
 * @param data : payload
 */
export function* updateServiceEventMappingData({
  data
}: UpdateServiceEventMappingRequest) {
  yield put(updateServiceEventMappings(data));
}

export function* updateServiceEventMappingDataSaga() {
  yield takeLatest(
    ingressServiceEvent.UPDATE_SERVICE_EVENT,
    updateServiceEventMappingData
  );
}

export const addServiceEventMappingsSaga = [fork(addServiceEventMappingSaga)];
export const clearServiceEventsMappingSaga = [fork(clearServiceEventMappingDataSaga)];
export const deleteServiceEventsMappingSaga = [fork(deleteServiceEventMappingDataSaga)];
export const updateServiceEventsMappingSaga = [fork(updateServiceEventMappingDataSaga)];
